import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/authentication/1.4-人工智能.svg'
import _imports_1 from '@/assets/authentication/1.5-人工.svg'
import _imports_2 from '@/assets/authentication/1.6-实地.svg'


const _withScopeId = n => (_pushScopeId("data-v-6a5fe35a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "terminal_list" }
const _hoisted_2 = { class: "screen" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "终端名称 / 编码", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "渠道", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "子渠道", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "省市区", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "街道", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "规模类型", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "认证方式", -1))
const _hoisted_10 = { class: "searchBox" }
const _hoisted_11 = { style: {"margin-top":"20px","background":"#fff","padding":"0 30px 20px","border-radius":"4px"} }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_13 = { style: {"margin-bottom":"20px","display":"flex","justify-content":"space-between","align-items":"center","height":"50px","box-shadow":"inset 0px -1px 0px 0px rgba(232, 232, 232, 1)"} }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "moduleTitle" }, "终端列表", -1))
const _hoisted_15 = { style: {"display":"flex","line-height":"0"} }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "刷新", -1))
const _hoisted_17 = { class: "batch" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "密度", -1))
const _hoisted_19 = { class: "SettingOutlinedBox" }
const _hoisted_20 = { class: "serialNumber" }
const _hoisted_21 = { class: "terminalNameContainer" }
const _hoisted_22 = { class: "iconbox" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "terminalNameBox longBox" }
const _hoisted_25 = ["onClick", "title"]
const _hoisted_26 = ["title"]
const _hoisted_27 = { key: 0 }
const _hoisted_28 = ["title"]
const _hoisted_29 = { key: 0 }
const _hoisted_30 = ["title"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "AI"
}, null, -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = ["title"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "人工"
}, null, -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = ["title"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "实地"
}, null, -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = { style: {"display":"flex","justify-content":"space-between","margin-top":"20px"} }
const _hoisted_40 = { style: {"margin":"0 10px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!
  const _component_Col = _resolveComponent("Col")!
  const _component_AllCategory = _resolveComponent("AllCategory")!
  const _component_Form = _resolveComponent("Form")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Cascader = _resolveComponent("Cascader")!
  const _component_Row = _resolveComponent("Row")!
  const _component_SearchOutlined = _resolveComponent("SearchOutlined")!
  const _component_Button = _resolveComponent("Button")!
  const _component_SyncOutlined = _resolveComponent("SyncOutlined")!
  const _component_ReloadOutlined = _resolveComponent("ReloadOutlined")!
  const _component_Popover = _resolveComponent("Popover")!
  const _component_ColumnHeightOutlined = _resolveComponent("ColumnHeightOutlined")!
  const _component_TagsFilled = _resolveComponent("TagsFilled")!
  const _component_Switch = _resolveComponent("Switch")!
  const _component_Table = _resolveComponent("Table")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Row, { class: "rowBox" }, {
        default: _withCtx(() => [
          _createVNode(_component_Col, {
            span: 4,
            class: "terminal_name"
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createVNode(_component_Input, {
                value: _ctx.fmesCodeOrName,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fmesCodeOrName) = $event)),
                placeholder: "请输入...",
                onKeyup: _withKeys(_ctx.search, ["enter"]),
                allowClear: ""
              }, null, 8, ["value", "onKeyup"])
            ]),
            _: 1
          }),
          _createVNode(_component_Col, { span: 1 }),
          _createVNode(_component_Col, { span: 4 }, {
            default: _withCtx(() => [
              _hoisted_4,
              _createVNode(_component_Form, { model: _ctx.formState }, {
                default: _withCtx(() => [
                  _createVNode(_component_AllCategory, {
                    formState: _ctx.formState,
                    style: {"width":"100%"},
                    allowClear: true
                  }, null, 8, ["formState"])
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _: 1
          }),
          _createVNode(_component_Col, { span: 1 }),
          _createVNode(_component_Col, { span: 4 }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createVNode(_component_Select, {
                class: "inputFixed",
                placeholder: "请选择",
                style: {"width":"100%"},
                value: _ctx.subChannel,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.subChannel) = $event)),
                "show-search": "",
                options: _ctx.optionsSubChannel,
                optionFilterProp: "label",
                allowClear: "",
                onSearch: _ctx.searchSubChannel
              }, null, 8, ["value", "options", "onSearch"])
            ]),
            _: 1
          }),
          _createVNode(_component_Col, { span: 1 }),
          _createVNode(_component_Col, { span: 4 }, {
            default: _withCtx(() => [
              _hoisted_6,
              _createVNode(_component_Cascader, {
                style: {"width":"100%"},
                "show-search": true,
                value: _ctx.regionValue,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.regionValue) = $event)),
                options: _ctx.options,
                placeholder: "请选择...",
                "change-on-select": "",
                allowClear: "",
                onChange: _ctx.changeCascader
              }, null, 8, ["value", "options", "onChange"])
            ]),
            _: 1
          }),
          _createVNode(_component_Col, { span: 1 }),
          _createVNode(_component_Col, { span: 4 }, {
            default: _withCtx(() => [
              _hoisted_7,
              _createVNode(_component_Select, {
                class: "inputFixed",
                placeholder: "请选择",
                style: {"width":"100%"},
                value: _ctx.town,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.town) = $event)),
                showSearch: "",
                options: _ctx.townOptions,
                allowClear: "",
                onFocus: _ctx.focusTown
              }, null, 8, ["value", "options", "onFocus"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_Row, { class: "rowBox" }, {
        default: _withCtx(() => [
          _createVNode(_component_Col, { span: 4 }, {
            default: _withCtx(() => [
              _hoisted_8,
              _createVNode(_component_Select, {
                class: "inputFixed",
                placeholder: "请选择",
                style: {"width":"100%"},
                value: _ctx.scaleType,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.scaleType) = $event)),
                "show-search": "",
                options: _ctx.optionsScaleType,
                optionFilterProp: "label",
                allowClear: ""
              }, null, 8, ["value", "options"])
            ]),
            _: 1
          }),
          _createVNode(_component_Col, { span: 1 }),
          _createVNode(_component_Col, { span: 4 }, {
            default: _withCtx(() => [
              _hoisted_9,
              _createVNode(_component_Select, {
                class: "inputFixed",
                placeholder: "请选择",
                style: {"width":"100%"},
                value: _ctx.taskStatus,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.taskStatus) = $event)),
                "show-search": "",
                options: _ctx.optionsTaskStatus,
                optionFilterProp: "label",
                allowClear: ""
              }, null, 8, ["value", "options"])
            ]),
            _: 1
          }),
          _createVNode(_component_Col, { span: 1 }),
          _createVNode(_component_Col, { span: 4 }),
          _createVNode(_component_Col, { span: 1 }),
          _createVNode(_component_Col, { span: 4 }),
          _createVNode(_component_Col, { span: 1 }),
          _createVNode(_component_Col, {
            span: 4,
            class: "searchBoxfather"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_Button, {
                  type: "primary",
                  onClick: _ctx.search
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SearchOutlined, { style: {"font-size":"14px","position":"relative","top":"1px"} }),
                    _createTextVNode("搜索")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_Button, {
                  style: {"margin-left":"10px","border-color":"#008bcf","color":"#008bcf"},
                  onClick: _ctx.reset
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SyncOutlined, { style: {"font-size":"14px","position":"relative","top":"1px"} }),
                    _createTextVNode("重置")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_Popover, null, {
            content: _withCtx(() => [
              _hoisted_16
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "SettingOutlinedBox",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
              }, [
                _createVNode(_component_ReloadOutlined)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Popover, {
            trigger: "click",
            placement: "bottom"
          }, {
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", {
                  class: _normalizeClass(this.batchStyle == 'default' ? 'active' : ''),
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.batchStyle = 'default'))
                }, " 宽松 ", 2),
                _createElementVNode("div", {
                  class: _normalizeClass(this.batchStyle == 'middle' ? 'active' : ''),
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.batchStyle = 'middle'))
                }, " 默认 ", 2),
                _createElementVNode("div", {
                  class: _normalizeClass(this.batchStyle == 'small' ? 'active' : ''),
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.batchStyle = 'small'))
                }, " 紧凑 ", 2)
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Popover, null, {
                content: _withCtx(() => [
                  _hoisted_18
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_ColumnHeightOutlined)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_Table, {
          rowKey: "fmesCode",
          columns: _ctx.columns,
          "data-source": _ctx.data,
          pagination: false,
          scroll: _ctx.scroll,
          loading: _ctx.loading,
          size: _ctx.batchStyle
        }, {
          serialNumber: _withCtx(({ index }) => [
            _createElementVNode("span", _hoisted_20, _toDisplayString(index + 1), 1)
          ]),
          terminalName: _withCtx(({ record }) => [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("a", {
                  onClick: ($event: any) => (_ctx.terminalDetails(record.fmesCode)),
                  href: "javascript:"
                }, [
                  _createVNode(_component_TagsFilled)
                ], 8, _hoisted_23)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("a", {
                    onClick: ($event: any) => (_ctx.terminalDetails(record.fmesCode)),
                    href: "javascript:",
                    class: "terminalName",
                    title: record.fmesName
                  }, _toDisplayString(record.fmesName), 9, _hoisted_25)
                ]),
                _createElementVNode("div", {
                  class: "terminalNameBox longBox",
                  style: {"color":"#ccc"},
                  title: record.storeShortId
                }, _toDisplayString(record.storeShortId), 9, _hoisted_26)
              ])
            ])
          ]),
          province: _withCtx(({ record }) => [
            _createElementVNode("div", null, [
              _createElementVNode("div", null, [
                _createTextVNode(_toDisplayString(record.province) + "/" + _toDisplayString(record.city) + "/" + _toDisplayString(record.area), 1),
                (record.town)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_27, "/" + _toDisplayString(record.town), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                class: "terminalNameBox",
                title: record.address
              }, [
                _createElementVNode("span", null, _toDisplayString(record.address), 1)
              ], 8, _hoisted_28)
            ])
          ]),
          taskStatus: _withCtx(({ record }) => [
            (record.terminalUnifyTypeCO)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  (record.terminalUnifyTypeCO.aiFlag)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        title: 
                  record.terminalUnifyTypeCO.aiFlag
                    ? 'AI认证' + record.terminalUnifyTypeCO.aiFlagDate
                    : ''
                
                      }, _hoisted_32, 8, _hoisted_30))
                    : _createCommentVNode("", true),
                  (record.terminalUnifyTypeCO.manualFlag)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        style: {"margin":"0 5px"},
                        title: 
                  record.terminalUnifyTypeCO.manualFlag
                    ? '人工认证' + record.terminalUnifyTypeCO.manualFlagDate
                    : ''
                
                      }, _hoisted_35, 8, _hoisted_33))
                    : _createCommentVNode("", true),
                  (record.terminalUnifyTypeCO.siteFlag)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 2,
                        title: 
                  '实地认证' + record.terminalUnifyTypeCO.siteFlag
                    ? record.terminalUnifyTypeCO.siteFlagDate
                    : ''
                
                      }, _hoisted_38, 8, _hoisted_36))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          handle: _withCtx(({ record }) => [
            _createVNode(_component_Switch, {
              disabled: !_ctx.$store.state.authc.authc.ButtonBasic_pg_basiData_terminalList_state,
              onChange: ($event: any) => (_ctx.terminalHandle(record.fmesCode, record.terminalStatus)),
              checked: _ctx.computeStatus(record.terminalStatus),
              size: "small"
            }, null, 8, ["disabled", "onChange", "checked"])
          ]),
          _: 1
        }, 8, ["columns", "data-source", "scroll", "loading", "size"])
      ]),
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("div", null, [
          _createTextVNode(" 共"),
          _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.total), 1),
          _createTextVNode("条数据 ")
        ]),
        _createVNode(_component_Pagination, {
          "show-size-changer": "",
          "show-quick-jumper": "",
          current: _ctx.pageCurrent,
          "onUpdate:current": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.pageCurrent) = $event)),
          pageSize: _ctx.pageSize,
          "onUpdate:pageSize": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.pageSize) = $event)),
          total: _ctx.total,
          onShowSizeChange: _ctx.onShowSizeChange,
          "page-size-options": ['10', '20', '50', '100']
        }, null, 8, ["current", "pageSize", "total", "onShowSizeChange"])
      ])
    ])
  ]))
}